/* eslint-disable jsx-a11y/anchor-is-valid */
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

import AOS from "aos";
import "aos/dist/aos.css";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showMenu, setShowMenu] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [roundedButtonPressed, setRoundedButtonPressed] = useState(false);
  const [activeButton, setActiveButton] = useState("efetivas");
  const [jobs, setJobs] = useState([]);
  const [allCategories, setAllCategories] = useState({});

  const closeMenu = () => {
    setShowMenu(false);
  };

  const handleButtonClick = (activeButton) => {
    setActiveButton(activeButton);

    filterJobsType(activeButton);
  };

  // paginação vagas
  const [currentPage, setCurrentPage] = useState(0);
  const [itemOffsetJobs, setItemOffsetJobs] = useState(0);
  const itemsPerPage = 5;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const endOffsetJobs = itemOffsetJobs + itemsPerPage;

  const currentJobs = filteredJobs?.slice(itemOffsetJobs, endOffsetJobs);

  const pageCountJobs = Math.ceil(filteredJobs?.length / itemsPerPage);

  const handlePageClickJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs?.length;
    setItemOffsetJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  useEffect(() => {
    AOS.init();
  }, []);

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  const filterJobsType = (activeButton) => {
    setShowLoader(true);
    setCurrentPage(0);
    setItemOffsetJobs(0);

    const category = allCategories?.groupedJobPositionList[activeButton];

    setJobs(category);

    setTimeout(() => {
      setShowLoader(false);
    }, 2000);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "mercadolivre",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setAllCategories(jobsData);
          setJobs(jobsData.groupedJobPositionList.efetivas);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div onMouseDown={closeMenu}>
      <nav className="bg-[#2074D9] h-25">
        <div className="flex items-center p-4 pr-[10%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Mercado Livre Landing Page Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-center items-center gap-16 mb-0 list-meu"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a
                href="#parceria"
                className="text-white hover:border-b-2 hover:border-white"
              >
                parceria Randstad
              </a>
            </li>
            <li>
              <a
                href="#sobre"
                className="text-white hover:border-b-2 hover:border-white"
              >
                sobre o Mercado Livre
              </a>
            </li>
            <li>
              <a
                href="#processo-seletivo"
                className="text-white hover:border-b-2 hover:border-white"
              >
                processo seletivo
              </a>
            </li>
            <li>
              <a
                href="#areas-de-atuacao"
                className="text-white hover:border-b-2 hover:border-white"
              >
                áreas de atuação
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center relative">
        <div
          id="main-title"
          className="absolute top-1/2 left-[15%] max-[768px]:left-[5%] transform -translate-y-1/2 flex flex-col z-10 max-[768px]:pb-8"
        >
          <p className="text-white text-4xl font-regular max-[768px]:text-lg">
            faça parte da logística
          </p>
          <p className="text-white ml-8 text-4xl md:pt-2 font-regular md:mt-2 max-[768px]:text-lg">
            mais rápida do Brasil.
          </p>
          <a href="#areas-de-atuacao">
            <button className="mt-[15%] bg-[#00D7FF] text-black px-14 py-3 text-xl rounded-full font-light max-[768px]:hidden">
              faça parte do nosso time!
            </button>
          </a>
        </div>
        <div className="w-full bg-cover bg-center">
          <img
            src="./assets/images/landing-image-3.png"
            alt="Mercado Livre Landing Page"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-[#F7F5F0] py-6 px-[7vw] max-[1024px]:px-4">
        <div
          id="parceria"
          className="w-full flex flex-row gap-6 max-[1024px]:flex-col"
        >
          <div className="flex flex-col items-center justify-center w-full gap-8 py-2 px-[2vw] max-[1024px]:px-2">
            <div className="flex items-center justify-center gap-8 max-[1024px]:gap-4 max-[768px]:w-[40%]">
              <img
                src="./assets/images/logo-rand.png"
                alt="Logo Randstad"
                className="w-full max-w-[40%] h-auto mr-4"
              />
              <img
                src="./assets/images/logo-mercado-livre.png"
                alt="Logo Mercado Livre"
                className="w-full max-w-[40%] h-auto"
              />
            </div>

            <div className="flex flex-col w-full md:mt-8">
              <p className="text-xl mb-4 max-w-full leading-7 text-[#0f1941]">
                O Mercado Livre, em parceria com a Randstad, promovem
                oportunidade de trabalho para logística. Durante o processo
                seletivo, você conhecerá mais sobre como funciona a operação da
                logística mais rápida do Brasil!
              </p>
              <p className="text-xl max-w-[75%] text-[#0f1941]">
                Você aceita o desafio?
              </p>
            </div>
          </div>

          <a href="#areas-de-atuacao" className="text-black">
            <button className="bg-[#00D7FF] px-6 py-2 w-full text-2xl rounded-full font-regular md:hidden">
              faça parte do nosso time!
            </button>
          </a>

          <div className="w-full flex justify-center max-[768px]:hidden">
            <img
              src="./assets/images/landing-image-4.png"
              alt="Imagem Mercado Livre"
              className="w-full max-w-[100%] max-h-[90%] max-[768px]:max-w-full"
            />
          </div>
        </div>
      </div>

      <div
        id="sobre"
        className="w-full bg-[#2074D9] flex justify-center items-center relative"
      >
        <div
          id="main-title"
          className="absolute top-[33%] lg:top-[50%] lg:left-[35%] transform -translate-y-1/2 flex flex-col z-10 max-[768px]:visible md:pr-24"
        >
          <p className="text-[#00D7FF] md:ml-8 max-[768px]:px-6 text-[32px] pb-2 font-regular md:mt-2 max-[768px]:text-xl">
            a experiência de transformar o comércio eletrônico e os serviços
            financeiros.
          </p>
          <p className="text-white md:ml-8 max-[768px]:px-6 font-regular mt-2 max-[768px]:text-base">
            O Mercado Livre é a companhia líder na oferta de tecnologia para o
            comércio eletrônico na América Latina e oferece soluções para
            pessoas e empresas. Focados em oferecer uma experiência em constante
            aprimoramento com objetivo de democratizar o comércio eletrônico,
            oferecendo a melhor plataforma e os serviços necessários e
            impactando no crescimento de toda a região.
          </p>
          <p className="text-white md:ml-8 max-[768px]:px-6 font-regular mt-2 max-[768px]:text-base">
            Com um #DNAMELI presente no dia a dia das pessoas colaboradoras e
            terceiros, a cultura MELI promove o aprendizado contínuo, te desafia
            a ser protagonista da sua carreira sempre trabalhando em equipe com
            diversão e te conectando às melhores oportunidades.
          </p>
          <p className="text-white md:ml-8 max-[768px]:px-6 font-regular mt-2 max-[768px]:text-base">
            Seguem incorporando talentos únicos, protagonistas de suas carreiras
            e guiados pela energia empreendedora de seus princípios culturais.
          </p>
        </div>

        <div className="w-full bg-cover bg-center lg:hidden">
          <img
            src="./assets/images/responsive-landing-image-1.png"
            alt="Mercado Livre Responsive Landing Page"
            className="w-full"
          />
        </div>

        <div className="w-full bg-cover bg-center max-[1024px]:hidden">
          <img
            src="./assets/images/landing-image-6.png"
            alt="Mercado Livre Landing Page"
            className="w-full"
          />
        </div>
      </div>

      <div
        id="processo-seletivo"
        className="flex w-full h-[950px] bg-[#F7F5F0] p-[48px] max-[768px]:h-auto max-[768px]:!p-0"
      >
        <div className="flex flex-col w-[100%] h-[100%] max-[768px]:w-full">
          <div className="flex h-[50%] max-[768px]:flex-col">
            <div className="flex flex-col w-[40%] max-[768px]:w-full max-[768px]:p-3 max-[768px]:text-left max-[768px]:mt-4">
              <h2 className="text-[#2175D9] text-[2vw] max-[768px]:text-2xl max-[768px]:px-3">
                prepare-se para um processo
              </h2>
              <h2 className="text-[#2175D9] text-[2vw] ml-[6vw] max-[768px]:text-2xl max-[768px]:ml-[12vw]">
                seletivo inovador e digital.
              </h2>
              <p className="text-[#0F1941] text-xl mt-3 w-[80%] max-[768px]:w-full max-[768px]:px-3">
                Através de um processo seletivo dinâmico, inovador e digital,
                nós da Randstad, preparamos etapas nas quais você poderá
                explorar todo seu potencial, com desafios que promovem a
                inclusão, a diversidade e gera momentos únicos e memoráveis aos
                nossos candidatos.
              </p>
            </div>
            <div className="flex flex-col w-[40%] gap-1 max-[768px]:w-full">
              <div className="flex items-center gap-4 w-full h-[83px] bg-[#00D7FF] rounded-l-full min-[1480px]:h-[87px]">
                <div className="flex items-center justify-center w-[83px] h-full bg-[#2175D9] rounded-full text-white text-4xl">
                  1.
                </div>
                <h5 className="first-text mb-0 text-2xl">candidatura.</h5>
              </div>
              <h5 className="text-[#2175D9] mt-3 text-2xl second-text">
                candidatura.
              </h5>
              <p className="w-[80%] pr-4 max-[768px]:p-6 max-[768px]:w-full">
                Para iniciar o seu processo, inscreva-se à vaga de seu interesse
                neste site. Você pode usar os filtros e o campo de pesquisa para
                encontrar a oportunidade mais adequada ao seu perfil. Uma vez
                encontrada, clique em "Quero essa Vaga" e siga os passos.
              </p>
            </div>
            <div className="vector h-[calc(100%+84px)] -ml-2 min-[1480px]:h-[calc(100%+87px)]">
              <img
                src="./assets/images/vector.svg"
                alt="Vector"
                className="h-full"
              />
            </div>
          </div>
          <div className="flex max-[768px]:flex-col-reverse w-[80%] max-[768px]:w-full">
            <div className="flex flex-col w-[25%] gap-1 max-[768px]:w-full">
              <div className="flex items-center gap-4 w-full h-[83px] bg-[#00D7FF] rounded-l-full min-[1480px]:h-[85px]">
                <div className="flex items-center justify-center w-[83px] h-full bg-[#2175D9] rounded-full text-white text-4xl">
                  5.
                </div>
                <h5 className="first-text mb-0 text-2xl">admissão. </h5>
              </div>
              <h5 className="text-[#2175D9] mt-3 text-2xl pr-8 second-text">
                admissão.
              </h5>
              <p className="pr-8 max-[768px]:p-6">
                Após uma experiência única e memorável, este é o momento mais
                esperado! Se aceitou também a nossa proposta, é hora de entregar
                os documentos necessários e passar pelo exame médico. Se estiver
                tudo ok, logo você fará parte de nossa equipe.
              </p>
            </div>
            <div className="flex flex-col w-[25%] gap-1 max-[768px]:w-full">
              <div className="flex items-center gap-4 w-full h-[83px] bg-[#00D7FF] max-[768px]:flex-row-reverse max-[768px]:rounded-r-full min-[1480px]:h-[85px]">
                <div className="flex items-center justify-center w-[83px] h-full bg-[#2175D9] rounded-full text-white text-4xl">
                  4.
                </div>
                <h5 className="first-text mb-0 text-2xl">
                  entrevista com a gestão.
                </h5>
              </div>
              <h5 className="text-[#2175D9] mt-3 text-2xl pr-8 second-text">
                entrevista com a gestão.
              </h5>
              <p className="pr-8 max-[768px]:p-6">
                Você está quase lá! Nessa etapa, prepare-se para uma entrevista
                final com os seus futuros gestores. Dica importante: pesquise
                sobre a empresa e prepare-se para trocar e compartilhar
                conhecimento e experiência conosco.
                <span className="text-[#2175d9]">
                  Em casos de vagas PcD, esta etapa só será realizada com a
                  validação do laudo médico.
                </span>
              </p>
            </div>
            <div className="flex flex-col w-[25%] gap-1 max-[768px]:w-full">
              <div className="flex items-center gap-4 w-full h-[83px] bg-[#00D7FF] max-[768px]:rounded-l-full min-[1480px]:h-[85px]">
                <div className="flex items-center justify-center w-[83px] h-full bg-[#2175D9] rounded-full text-white text-4xl max-[768px]:min-w-[83px]">
                  3.
                </div>
                <h5 className="first-text mb-0 text-2xl">
                  entrevista em grupo ou individual.
                </h5>
              </div>
              <h5 className="text-[#2175D9] mt-3 text-2xl pr-8 second-text">
                entrevista em grupo ou individual.
              </h5>
              <p className="pr-8 max-[768px]:p-6">
                Chegou a hora de você exercer a sua criatividade e mostrar suas
                habilidades colaborativas através de uma Dinâmica em Grupo.
                Nesta etapa, traremos um desafio resistente, que exigirá uma
                solução técnica e inovadora para transformar esta ocasião.
              </p>
            </div>
            <div className="flex flex-col w-[25%] gap-1 max-[768px]:w-full">
              <div className="flex items-center gap-4 w-full h-[83px] bg-[#00D7FF] max-[768px]:flex-row-reverse max-[768px]:rounded-r-full min-[1480px]:h-[85px]">
                <div className="flex items-center justify-center w-[83px] h-full bg-[#2175D9] rounded-full text-white text-4xl">
                  2.
                </div>
                <h5 className="first-text mb-0 text-2xl">teste cognitivo.</h5>
              </div>
              <h5 className="text-[#2175D9] mt-3 text-2xl second-text">
                teste cognitivo.
              </h5>
              <p className="pr-4 max-[768px]:p-6">
                Nessa etapa, você irá realizar um teste que avaliará suas
                habilidade cognitivas, o teste será realizado de forma virtual.
                Este teste é uma oportunidade para demonstrar suas habilidades
                cognitivas e raciocínio lógico. Faça o seu melhor.{" "}
                <span className="text-[#2175d9]">
                  Etapa realizada apenas em vagas elegíveis.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        id="proposito"
        className="w-full bg-[#2175D9] flex flex-row mb-16 gap-6 px-[7vw] max-[768px]:pl-0 max-[768px]:pr-8 justify-center items-center"
      >
        <div className="w-[35%] max-[768px]:hidden">
          {!roundedButtonPressed ? (
            <img
              src="./assets/images/landing-image-7.png"
              alt="Mercado Livre Landing Page"
              className="w-full h-[80%]"
              data-aos="fade-right"
              data-aos-delay="100"
            />
          ) : (
            <img
              src="./assets/images/landing-image-8.png"
              alt="Mercado Livre Landing Page"
              className="w-full h-[80%]"
              data-aos="fade-right"
              data-aos-delay="100"
            />
          )}
        </div>

        <div className="w-[65%] ml-[10%] flex flex-col max-[768px]:w-full max-[768px]:mt-12">
          <div className="mt-6 max-[768px]:w-full">
            {!roundedButtonPressed ? (
              <div className="" data-aos="fade-right" data-aos-delay="100">
                <h1 className="text-4xl font-regular text-black max-[768px]:text-2xl max-[768px]:px-2">
                  gerando um ambiente de
                </h1>
                <h1 className="text-4xl font-regular ml-[25%] text-black mb-4 max-[768px]:text-2xl max-[768px]:ml-32">
                  respeito e inclusão.
                </h1>
                <div className="space-y-2 max-[768px]:px-2">
                  <p className="text-xl text-white max-[768px]:text-lg">
                    No MELI você é livre para ser quem você é!
                  </p>
                </div>
                <div className="space-y-2 mb-6 max-[768px]:px-2">
                  <p className="text-xl text-white max-[768px]:text-lg">
                    A busca de democratizar as perspectivas e incluir diferentes
                    pensamentos. Pois, entende-se que a diversidade é uma
                    vantagem competitiva sendo a principal fonte de inovação,
                    construindo um comportamento disruptivo.
                  </p>
                </div>
                <a href="#areas-de-atuacao">
                  <button className="mt-[10%] bg-[#00D7FF] text-black px-6 py-8 max-[768px]:py-3 w-full text-3xl max-[768px]:text-2xl max-[768px]:mb-12 rounded-full font-regular">
                    faça parte do nosso time!
                  </button>
                </a>
              </div>
            ) : (
              <div className="" data-aos="fade-right" data-aos-delay="100">
                <div className="max-[768px]:p-2 md:p-12 flex flex-col gap-6 md:gap-8">
                  <div className="flex items-center gap-12">
                    <span className="text-4xl md:text-3xl lg:text-8xl font-regular text-[#00D7FF]  flex max-[768px]:items-center">
                      42%
                    </span>
                    <p className="mb-0 text-white text-2xl max-[768px]:text-lg">
                      das pessoas que fazem parte do MELI são mulheres,
                      superando a média do mercado de TI e Logística.
                    </p>
                  </div>

                  <div className="flex items-center gap-12">
                    <span className="text-4xl md:text-3xl lg:text-8xl font-regular text-[#00D7FF] flex max-[768px]:items-center">
                      92%
                    </span>
                    <p className="mb-0 text-white text-2xl max-[768px]:text-lg">
                      dos nossos colaboradores afirmam sentir-se em um ambiente
                      que promove a inclusão.
                    </p>
                  </div>

                  <div className="flex items-center gap-12">
                    <span className="text-4xl md:text-5xl lg:text-8xl font-regular text-[#00D7FF] flex max-[768px]:items-center">
                      45%
                    </span>
                    <p className="mb-0 text-white text-2xl max-[768px]:text-lg">
                      das pessoas que trabalham no MELI Brasil se declaram
                      negras. Buscamos que todas as vozes estejam representadas.
                    </p>
                  </div>

                  <a href="#areas-de-atuacao">
                    <button className="mt-[10%] bg-[#00D7FF] text-black px-14 py-4 text-3xl rounded-full font-regular max-[768px]:hidden">
                      faça parte do nosso time!
                    </button>
                  </a>
                </div>
              </div>
            )}

            <div className="flex justify-center">
              <div className="bg-white flex flex-row h-10 justify-around w-[50%] mb-12 md:mt-24 max-[768px]:mt-0 md:w-[40%] rounded-full">
                <a
                  className="cursor-pointer"
                  onClick={() => {
                    setRoundedButtonPressed(false);
                  }}
                >
                  <div
                    className={`${
                      roundedButtonPressed ? "bg-[#CFD1D9]" : "bg-[#0F1940]"
                    } h-[100%] w-10 rounded-full`}
                  />
                </a>
                <a
                  className="cursor-pointer"
                  onClick={() => {
                    setRoundedButtonPressed(true);
                    AOS.refresh();
                  }}
                >
                  <div
                    className={`${
                      roundedButtonPressed ? "bg-[#0F1940]" : "bg-[#CFD1D9]"
                    } h-[100%] w-10 rounded-full`}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center mb-16">
        <div
          className="flex flex-row w-full items-end justify-between md:pl-24 md:pr-24 max-lg:w-[90%]"
          id="areas-de-atuacao"
        >
          <div className="flex flex-col w-[40%] mb-12 max-[768px]:w-[100%]">
            <h1 className="text-4xl font-light text-blue-500 mb-4">
              vagas abertas.
            </h1>
            <p className="text-xl text-black">
              muito mais que um emprego!
              <br />
              uma experiência única e colaborativa de democratizar o comércio.
            </p>
          </div>

          <div>
            <select
              id="select-1"
              onChange={onChangeFilterJobsCity}
              className="filter-btn w-[250px] mb-4 p-2 cursor-pointer h-12 max-[768px]:hidden"
            >
              <option value="">Todas as cidades</option>
              {jobPositionCity.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
                </option>
              ))}
            </select>
            <select
              id="select-2"
              onChange={onChangeFilterJobsTitle}
              className="filter-btn w-[250px] mb-4 p-2 ml-4 cursor-pointer h-12 max-[768px]:hidden"
            >
              <option value="">Todas os cargos</option>
              {jobPositionTitle.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <select
          id="select-1"
          onChange={onChangeFilterJobsCity}
          className="filter-btn w-[90%] mb-4 p-2 cursor-pointer h-12 md:hidden"
        >
          <option value="">Todas as cidades</option>
          {jobPositionCity.map((jobId, i) => (
            <option value={jobId.id} key={i}>
              {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
            </option>
          ))}
        </select>

        <select
          id="select-2"
          onChange={onChangeFilterJobsTitle}
          className="filter-btn w-[90%] mb-4 p-2 cursor-pointer h-12 md:hidden"
        >
          <option value="">Todas os cargos</option>
          {jobPositionTitle.map((jobId, i) => (
            <option value={jobId.id} key={i}>
              {jobId.name}
            </option>
          ))}
        </select>

        <div
          className="w-[90%] flex flex-col justify-center py-14 px-[7vw] bg-[#00D7FF] rounded-3xl"
          id="oportunidades"
        >
          <select
            onChange={(e) => handleButtonClick(e.target.value)}
            id="select-3"
            className="filter-btn w-full mb-4 p-2 cursor-pointer h-12 md:hidden"
          >
            <option value="efetivas">vagas efetivas.</option>
            <option value="afirmativas">vagas afirmativas.</option>
            <option value="banco_talentos">banco de talentos.</option>
          </select>

          <div className="flex flex-row w-full place-content-around max-[768px]:hidden">
            <button
              onClick={() => handleButtonClick("efetivas")}
              className={`${
                activeButton === "efetivas" ? "bg-[#2175D9]" : "bg-[#0F1940]"
              } px-12 max-[768px]:px-6 py-2 mb-12 self-center text-xl text-white rounded-full font-regular max-[768px]:text-base`}
            >
              vagas efetivas.
            </button>

            <button
              onClick={() => handleButtonClick("afirmativas")}
              className={`${
                activeButton === "afirmativas" ? "bg-[#2175D9]" : "bg-[#0F1940]"
              } px-8 max-[768px]:px-6 py-2 mb-12 self-center text-xl text-white rounded-full font-regular max-[768px]:text-base`}
            >
              vagas afirmativas.
            </button>

            <button
              onClick={() => handleButtonClick("banco_talentos")}
              className={`${
                activeButton === "banco_talentos"
                  ? "bg-[#2175D9]"
                  : "bg-[#0F1940]"
              } px-8 max-[768px]:px-6 py-2 mb-12 self-center text-xl text-white rounded-full font-regular max-[768px]:text-base`}
            >
              banco de talentos.
            </button>
          </div>

          {showLoader && (
            <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
              <Spinner animation="grow" variant="primary" />
              <h4 className="text-white mt-4">Carregando</h4>
            </div>
          )}

          {!showLoader && currentJobs?.length ? (
            <>
              <ul className="w-full">
                {currentJobs.map((job, i) => (
                  <li className="jobs-list" key={i}>
                    <div className="w-full pl-3 max-[768px]:w-full max-[768px]:p-0">
                      <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                    </div>
                    <div className="w-[30%] flex justify-end max-[768px]:justify-center max-[768px]:w-full">
                      <Button
                        className="py-3 w-full md:px-5 cursor-pointer self-end rounded-full"
                        variant="primary"
                        href={job.shortUrl}
                        target="_blank"
                      >
                        candidatar-se
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>
              <ReactPaginate
                containerClassName="pagination"
                breakLabel="..."
                nextLabel="Próximo >"
                onPageChange={handlePageClickJobs}
                marginPagesDisplayed={2}
                pageCount={pageCountJobs}
                forcePage={currentPage}
                previousLabel="< Anterior"
                renderOnZeroPageCount={null}
              />
            </>
          ) : null}
          {!showLoader && !currentJobs?.length ? (
            <div className="jobs-list justify-center">
              <h2 className="text-blue-500 text-xl">
                Não encontramos resultados para sua busca.
              </h2>
            </div>
          ) : null}
        </div>
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-16">
        <p className="text-black text-2xl mb-8">
          Buscando dicas para a sua carreira? Confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          rel="noreferrer"
          className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white pt-8 max-[768px]:pb-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white underline hover:no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
